module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/shinjuku_sns_06-18d58f6aec15d9906565110b3ab86e69.jpg";